import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CandlestickCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { CANDLE_STICK_CHART } from "../../../../Data/Charts/ApexChart";

const CandlestickChart = () => {
  return (
    <Col sm="12" xl="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={CandlestickCharts} />
        <CardBody>
          <div id="candlestick">
            <Chart options={CANDLE_STICK_CHART} series={CANDLE_STICK_CHART.series} type="candlestick" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CandlestickChart;
